
jQuery(document).ready(function () {
	wowo(jQuery);
	menu();
	pdp();
	plp();
	pcp();
	resize_items();
	swiper_items();
	faqs();
	orders();
	headerHeight();
	gallerySliderHeight();
	sellingPlansArrowHide();
	subMenuFullWidth();
	checkSearchbarExist();
	checkSubscription();
	humbergerTopPosition();
});



// If the user if editing the page or animations are disabled, remove the wowo class.
if (Shopify.designMode === true || wowoAnimations == "false") {
	jQuery('html').removeClass("show-c");
	jQuery('.wowo').removeClass("wowo");
} else {
	jQuery(window).scroll(function () {
		wowo(jQuery);
	});
}


// Listen for new sections added to the page
if (Shopify.designMode) {
	document.addEventListener('shopify:section:load', () => {
		jQuery('html').removeClass("show-c");
		jQuery('.wowo').removeClass("wowo");
	});
}


$(window).load(function () {
	checkSubscription()
});
jQuery(window).resize(function () {
	resize_items();
	headerHeight();
	gallerySliderHeight();
	subMenuFullWidth();
	checkSubscription();
	humbergerTopPosition();
});

function wowo($) {
	setTimeout(function () {
		jQuery('html').addClass("show-c");

		var wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;
		jQuery(".wowo:not(.animated)").each(function () {
			var me = jQuery(this), meTop = me.offset().top, meHeight = me.height(), meBottom = meTop + meHeight,
				limitTop = wTop - meHeight, limitBottom = wBottom + meHeight;
			if (meTop > limitTop && meBottom < limitBottom) {
				me.addClass("animated");
				setTimeout(function () {
					me.removeClass("animated wowo");
				}, 1500);
			}
		})
	}, 100);

}

function menu() {

	jQuery('.hamburger').click(function () {
		jQuery("html").css("overflow", "hidden");
		jQuery(".header .header__menu").toggleClass('is-open');
		jQuery(".account-header .account-header__left .header__menu").toggleClass('is-open');

		jQuery(this).toggleClass('open');
		if (jQuery(this).hasClass("open")) {
			jQuery("html").css("overflow", "hidden");
		} else {
			jQuery("html").css("overflow", "inherit");
		}

	});


	jQuery(
		".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .menu-arrow"
	).click(function (e) {
		if ($(".section-header").hasClass("tablet-menu-collapse")) {
			if (jQuery(window).width() < 1200) {
				jQuery(this).parent().siblings(".sub-menu-content").addClass("is-open");
				jQuery("html").css("overflow", "hidden");
			}
		}
		else {
			if (jQuery(window).width() < 992.5) {
				jQuery(this).parent().siblings(".sub-menu-content").addClass("is-open");
				jQuery("html").css("overflow", "hidden");
			}
		}
	});

	jQuery(
		".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .menu-arrow"
	).each(function () {
		var this_c = jQuery(this);
		var text_c = this_c.siblings("a").text();
		this_c
			.parent()
			.siblings(".sub-menu-content")
			.prepend("<a class='back'>" + text_c + "</a>");
	});

	jQuery("body").on("click", ".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content>.back", function (e) {
		e.preventDefault();
		jQuery(this).parents(".sub-menu-content").removeClass("is-open");
	});

	jQuery(".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content .sub-menu-content__box>ul>li>a").click(function (e) {
		e.preventDefault();
		e.stopPropagation();
		if ($(".section-header").hasClass("tablet-menu-collapse")) {
			if (jQuery(window).width() < 1200) {
				jQuery(this).siblings(".sub-menu").addClass("is-open");
			}
		}
		else {
			if (jQuery(window).width() < 992.5) {
				jQuery(this).siblings(".sub-menu").addClass("is-open");
			}
		}
	});


	jQuery(".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content .sub-menu-content__box>ul>li>a").each(function () {
		var this_c = jQuery(this);
		var text_c = this_c.text();
		this_c.siblings(".sub-menu").prepend("<a class='back'>" + text_c + "</a>");
	});

	jQuery("body").on("click", ".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content .sub-menu-content__box>ul>li> .sub-menu .back", function (e) {
		e.preventDefault();
		jQuery(this).parents(".sub-menu").removeClass("is-open");
	});

	//style--2
	jQuery("body").on("click", ".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.full-megamenu .sub-menu-content .sub-menu-content__box>ul>li span", function (e) {
		e.preventDefault();
		console.log("dad");

		if ($(".section-header").hasClass("tablet-menu-collapse")) {
			if (jQuery(window).width() < 1200) {
				jQuery(this).siblings("ul").addClass("is-open");
			}
		}
		else {
			if (jQuery(window).width() < 992.5) {
				jQuery(this).siblings("ul").addClass("is-open");
			}
		}
	});

	jQuery(".header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.full-megamenu .sub-menu-content .sub-menu-content__box>ul>li span").each(function () {
		var this_c = jQuery(this);
		var text_c = this_c.text();
		this_c.siblings(".sub-menu").prepend("<a class='back'>" + text_c + "</a>");
	});






	//new
	jQuery("body .header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content .sub-menu-content__box>ul>li").hover(function (e) {
		jQuery(this).addClass("is-active");
		jQuery(this).siblings().removeClass("is-active");

	});




}


function orders() {
	jQuery(".orders-listing__title .buttons .grid-or-list a.list").click(function (e) {
		e.preventDefault();
		jQuery(this).addClass("active");
		jQuery(this).siblings().removeClass("active");
		jQuery(".orders-listing__items").addClass("hide");
		setTimeout(function () {
			jQuery(".orders-listing__items").addClass("list");
		}, 300);
		setTimeout(function () {
			jQuery(".orders-listing__items").removeClass("hide");
		}, 500);

	});

	jQuery(".orders-listing__title .buttons .grid-or-list a.grid").click(function (e) {
		e.preventDefault();
		jQuery(this).addClass("active");
		jQuery(this).siblings().removeClass("active");
		jQuery(".orders-listing__items").addClass("hide");
		setTimeout(function () {
			jQuery(".orders-listing__items").removeClass("list");
		}, 300);
		setTimeout(function () {
			jQuery(".orders-listing__items").removeClass("hide");
		}, 500);
	});

	jQuery(".orders-detail__content__left__item .item__accordion .item__accordion__title h2").click(function (e) {
		e.preventDefault();
		jQuery(this).parents(".item__accordion__title").toggleClass('is-active');
		jQuery(this).parents(".item__accordion__title").siblings(".item__accordion__text").slideToggle(300);

		if (jQuery(this).parents(".item__accordion__title").hasClass("is-active")) {
			jQuery(this).find(".show").text("Hide details");
		} else {
			jQuery(this).find(".show").text("Show details");
		}

	});
	jQuery(".add-link").click(function (e) {
		e.preventDefault();
		jQuery(".add-modal").addClass('is-show');
		jQuery("html").css("overflow", "hidden");


	});
	jQuery(".close-add-modal").click(function (e) {
		e.preventDefault();
		jQuery(".add-modal").removeClass('is-show');
		jQuery("html").css("overflow", "inherit");

	});
	jQuery(".add-modal").click(function (e) {
		e.stopPropagation();
		jQuery(".add-modal").removeClass('is-show');
		jQuery("html").css("overflow", "inherit");

	});
	jQuery(".add-modal__boxed").click(function (e) {
		e.stopPropagation();

	});


	jQuery(".edit-link").click(function (e) {
		e.preventDefault();

		jQuery(this).parents(".profile-detail__item__box").find(".edit-modal").addClass('is-show');
		jQuery("html").css("overflow", "hidden");

	});
	jQuery(".close-edit-modal").click(function (e) {
		e.preventDefault();
		jQuery(".edit-modal").removeClass('is-show');
		jQuery("html").css("overflow", "inherit");

	});
	jQuery(".edit-modal").click(function (e) {
		e.stopPropagation();
		jQuery(".edit-modal").removeClass('is-show');
		jQuery("html").css("overflow", "inherit");

	});
	jQuery(".edit-modal__boxed").click(function (e) {
		e.stopPropagation();
	});

	if (jQuery(".testimonials-cards").length > 0) {
		jQuery(".text-and-image").addClass("frist--style");
	}
}
function pdp() {
	jQuery(".go-to-bundle").click(function (e) {
		e.preventDefault();
		var bundle = jQuery(".selleasy-block-fbt");
		var he_h = jQuery("header").height();
		jQuery('html,body').stop().animate({ scrollTop: bundle.offset().top - he_h - 100 }, 600);
	});


}

function pcp() {


	jQuery(".image-and-service-cards__img .image-and-service-cards__img__popup .cards__img__colse").click(function (e) {
		e.preventDefault();
		jQuery(this).toggleClass('active');

	});
	jQuery(".banner-pcp__content .links .btn-white").click(function (e) {
		e.preventDefault();
		var index_c = jQuery(this).index();
		index_c = index_c - 1;
		jQuery(this).addClass('active');
		jQuery(this).siblings().removeClass('active');
		jQuery(".column-cards-category-full-width__swiper").removeClass('active');
		jQuery(".column-cards-category-full-width__swiper").eq(index_c).addClass('active');
	});
	jQuery('.text-read-more').each(function () {
		var this_c = jQuery(this);

		if (this_c.find('p').length > 1) {
			var firstParagraph = this_c.find('p').first().prop('outerHTML');
			var remainingParagraphs = this_c
				.find('p')
				.not(':first')
				.map(function () {
					return $(this).prop('outerHTML');
				})
				.get()
				.join('');
			this_c
				.children('.text-read-more__show')
				.append("<div class='text__first'><h2>" + firstParagraph + '</h2></div>');
			if (remainingParagraphs != '') {
				this_c
					.children('.text-read-more__show')
					.append("<div class='text__last'>" + remainingParagraphs + '</div>');
				this_c
					.children('.text-read-more__show')
					.append("<a href='#' class='link-border read-more'>Read More</a>");
			}
		} else {
			var firstParagraph = this_c.find('p').first().prop('outerHTML');
			this_c.children('.text-read-more__show').append("<div class='text__first'><h2>" + firstParagraph + '</h2></div>');
		}
	});
	jQuery('body').on('click', '.text-read-more__show .read-more', function (event) {
		event.preventDefault();
		var this_c = jQuery(this);
		jQuery(this).toggleClass('is-active');
		jQuery(this).siblings('.text__last').slideToggle(300);
		if (jQuery(this).hasClass('is-active')) {
			this_c.text('Less');
		} else {
			this_c.text('Read more');
		}
	});
}

function plp() {
	jQuery('body').on('change', '#SortByPC', function () {
		var val = jQuery(this).val();
		jQuery('input[name="sort_by"][value="' + val + '"]').prop('checked', true);
	});


	jQuery("body").on("click", ".plp-listing__content__category__box .filter-accordion .accordion-title", function (e) {

		e.preventDefault();
		jQuery(this).toggleClass("active");
		jQuery(this).siblings(".accordion-content").slideToggle(300);
	});

	jQuery("body").on("click", ".mobile-facets__open", function (e) {
		e.preventDefault();

		jQuery("body .plp-listing__content__category__box .facets.small-hide").addClass("open");
	});

	jQuery("body").on("click", ".close-filter-popup-btn", function (e) {

		e.preventDefault();

		jQuery("body").removeClass("overflow-hidden-mobile");
		jQuery("body .plp-listing__content__category__box .facets.small-hide").removeClass("open");
	});
	jQuery("body").on("click", ".plp-listing__content__category__box .mobile-filter-bottom-btn a", function (e) {

		e.preventDefault();
		jQuery("body").removeClass("overflow-hidden-mobile");
		jQuery("body .plp-listing__content__category__box .facets.small-hide").removeClass("open");
	});

	jQuery('body').on('click', '.product-item.click-to-detail', function () {

		if (jQuery(this).find(".ajax-quick-view").length > 0) {

		} else {
			jQuery(this).find(".product-item__img").find("a")[0].click();
		}


	});

}


function resize_items() {
	var he = 0;
	jQuery("body .header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content .sub-menu-content__box>ul>li .sub-menu").each(function (e) {
		var he_c = jQuery(this).outerHeight();
		if (he_c > he) {
			he = he_c;
		}
	});
	console.log(he);
	jQuery("body .header .header__menu .header__menu__overflow .header__menu__overflow__box .menu>li.menu-item-has-children .sub-menu-content .sub-menu-content__box").css("min-height", he);
	var Swiper4;
	if (jQuery(window).width() <= 768) {
		if (jQuery(".product-gallery").length > 0 && !Swiper4) {
			Swiper4 = new Swiper(".product-gallery", {
				loop: true,
				effect: "fade",
				autoplay: {
					delay: 3000,
					stopOnLastSlide: false,
					disableOnInteraction: true,
				},
				pagination: {
					el: '.product-gallery .swiper-pagination',
					clickable: true,
				},
			});
		}
	} else {
		if (Swiper4) {
			Swiper4.destroy(true, true);
			Swiper4 = undefined;
		}
	}

	var Swiper8;
	if (jQuery(window).width() <= 992) {
		if (jQuery(".category-item__swiper").length > 0 && !Swiper8) {
			Swiper8 = new Swiper(".category-item__swiper", {
				speed: 800,
				slidesPerView: "auto",
				resistance: true,
				pagination: {
					el: '.category-item__swiper .swiper-pagination',
					type: 'progressbar',
					clickable: true,
				},
			});
		}
	} else {
		if (Swiper8) {
			Swiper8.destroy(true, true);
			Swiper8 = undefined;
		}
	}


	var Swiper12;
	if (jQuery(window).width() <= 768) {
		if (jQuery(".column-4-block__content").length > 0 && !Swiper12) {
			Swiper12 = new Swiper(".column-4-block__content", {
				speed: 800,
				slidesPerView: "auto",
				resistance: true,
				pagination: {
					el: '.column-4-block__content .swiper-pagination',
					type: 'progressbar',
					clickable: true,
				},
			});
		}
	} else {
		if (Swiper12) {
			Swiper12.destroy(true, true);
			Swiper12 = undefined;
		}
	}

	var Swiper10;
	if (jQuery(window).width() <= 768) {
		if (jQuery(".post-cards__swiper").length > 0 && !Swiper10) {
			Swiper10 = new Swiper(".post-cards__swiper", {
				speed: 800,
				slidesPerView: "auto",
				resistance: true,
				pagination: {
					el: '.post-cards__swiper .swiper-pagination',
					type: 'progressbar',
					clickable: true,
				},
			});
		}
	} else {
		if (Swiper10) {
			Swiper10.destroy(true, true);
			Swiper10 = undefined;
		}
	}


}


function swiper_items() {
	if (jQuery(".header__swiper").length > 0) {
		const announcementBar = jQuery(".announcement-bar-wrapper");
		const autoplayMode = announcementBar.data('autoplay');
		const speed = parseInt(announcementBar.data('speed')) * 1000 || 3000;
		let swiperConfig = {
			loop: true,
			effect: "fade",
		};

		if (autoplayMode === 'autoplay') {
			swiperConfig.autoplay = {
				delay: speed,
				stopOnLastSlide: false,
				disableOnInteraction: true,
			};
		}

		var Swiper1 = new Swiper(".header__swiper", swiperConfig);
	}
	if (jQuery(".pdp-bundle__swiper").length > 0) {
		var Swiper2 = new Swiper(".pdp-bundle__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			pagination: {
				el: '.pdp-bundle__swiper .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},

		});
		jQuery(".pdp-bundle__swiper").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 4) {
				jQuery(this).addClass("cursor-inherit");
			}
		});
	}
	if (jQuery(".testimonial__swiper").length > 0) {
		var Swiper2 = new Swiper(".testimonial__swiper", {
			slidesPerView: "auto",
			loop: true,
			speed: 5000, // Higher means slower movement
			autoplay: {
				delay: 0, // No delay between transitions
			},
			pagination: {
				el: '.testimonial__swiper .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},

		});
		jQuery(".testimonial__swiper").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 4) {
				jQuery(this).addClass("cursor-inherit");
			}
		});
	}
	if (jQuery(".pdp-slos-like__swiper").length > 0) {
		var Swiper3 = new Swiper(".pdp-slos-like__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			pagination: {
				el: '.pdp-slos-like__swiper .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},
		});
		jQuery(".pdp-slos-like__swiper").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 4) {
				jQuery(this).addClass("cursor-inherit");
			}
		});
	}

	if (jQuery(".pdp-testimonials__swiper").length > 0) {
		var Swiper5 = new Swiper(".pdp-testimonials__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			pagination: {
				el: '.pdp-testimonials__swiper .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},

		});
		jQuery(".pdp-testimonials__swiper").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 4) {
				jQuery(this).addClass("cursor-inherit");
			}
		});

	}

	if (jQuery(".trending-badges__swiper").length > 0) {
		var Swiper6 = new Swiper(".trending-badges__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,

		});
		jQuery(".trending-badges__swiper").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 7) {
				jQuery(this).addClass("cursor-inherit");
			}
		});
	}
	if (jQuery(".column-cards__swiper").length > 0) {
		var Swiper7 = new Swiper(".column-cards__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			pagination: {
				el: '.column-cards__swiper .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},
		});
		jQuery(".column-cards__swiper").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 4) {
				jQuery(this).addClass("cursor-inherit");
			}
		});
	}

	// multi column swiper
	if (jQuery(".multicolumn__swiper").length > 0) {
		const isDesktop = jQuery(window).width() >= 990;
		const swiperClass = isDesktop
			? ".multicolumn_desktop_swiper"
			: ".multicolumn_mobile_swiper";

		function initializeSwiper(selector) {
			new Swiper(selector, {
				speed: 800,
				slidesPerView: "auto",
				resistance: true,
				pagination: {
					el: `${selector} .swiper-pagination`,
					type: "progressbar",
					clickable: true,
				},
			});

			jQuery(selector).each(function () {
				if (jQuery(this).find(".swiper-slide").length <= 4) {
					jQuery(this).addClass("cursor-inherit");
				}
			});
		}

		initializeSwiper(swiperClass);
	}


	if (jQuery(".column-cards-category-full-width__swiper").length > 0) {
		var Swiper10 = new Swiper(".column-cards-category-full-width__swiper", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			pagination: {
				el: '.column-cards-category-full-width__swiper .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},
		});
		jQuery(".column-cards-category-full-width__swiper").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 6) {
				jQuery(this).addClass("cursor-inherit");
			}
		});
	}

	if (jQuery(".testimonials-cards__content").length > 0) {
		var Swiper11 = new Swiper(".testimonials-cards__content", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			pagination: {
				el: '.testimonials-cards__content .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},
		});
		jQuery(".testimonials-cards__content").each(function () {
			if (jQuery(this).find(".swiper-slide").length <= 2) {
				jQuery(this).addClass("cursor-inherit");
			}
		});
	}

	if (jQuery(".related-blogs__content").length > 0) {
		var Swiper13 = new Swiper(".related-blogs__content", {
			speed: 800,
			slidesPerView: "auto",
			resistance: true,
			pagination: {
				el: '.related-blogs__content .swiper-pagination',
				type: 'progressbar',
				clickable: true,
			},
		});
	}

	if (jQuery(".logo-list").length > 0) {

		console.log("logo list being rendered")
		var Swiper14 = new Swiper(".logo-list", {
			speed: 800,
			slidesPerView: "3",
			resistance: true
		});
	}

	if (jQuery(".product-gallery-popup-item__img").length > 0) {
		// Check if this is the new PDP
		const isNewPDP = jQuery('.pdp-details.pdp-new').length > 0;
		
		// For new PDP: Check if zoom is enabled
		const zoomEnabled = isNewPDP && jQuery('.pdp-details.pdp-new').attr('data-zoom-enabled') === 'true';
		if (zoomEnabled) {
			const zoomInButton = document.getElementById('zoom-in-button');
			const zoomOutButton = document.getElementById('zoom-out-button');
			if (zoomInButton && zoomOutButton) {
				zoomInButton.addEventListener('click', () => {
					Swiper15.zoom.in();
				});
				zoomOutButton.addEventListener('click', () => {
					Swiper15.zoom.out();
				});
			}
		}

		var Swiper15 = new Swiper(".product-gallery-popup-item__img", {
			speed: 300,
			slidesPerView: "auto",
			spaceBetween: 100,
			resistance: true,
			navigation: {
				nextEl: ".product-gallery-popup-item__img .swiper-button-next",
				prevEl: ".product-gallery-popup-item__img .swiper-button-prev",
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			zoom: {
				enabled: zoomEnabled,
				toggle: zoomEnabled,
				panOnMouseMove: zoomEnabled,
				maxRatio: 2,
			},
		});

		const lightboxEnabled = isNewPDP ? jQuery('.pdp-details.pdp-new').attr('data-lightbox-enabled') === 'true' : true;
		
		if (lightboxEnabled) {
			jQuery("body").on("click", ".pdp-details__item__left__box .product-gallery .swiper-wrapper .swiper-slide", function (e) {

				// For new PDP: Don't trigger zoom if clicking on the icon
				if (isNewPDP && jQuery(e.target).closest('.icon-preview-slider-img').length > 0) {
					return;
				}

				e.preventDefault();
				jQuery('.product-gallery-popup').fadeIn(300);
				var index = jQuery(this).index();


				Swiper15.slideTo(index);
				jQuery("html").css("overflow", "hidden");

				// For new PDP: Check if autoplay is enabled before auto-playing video
				// For old PDP: Always autoplay video
				const videoAutoplayEnabled = isNewPDP ? jQuery('.pdp-details.pdp-new').attr('data-video-autoplay') === 'true' : true;
				if (videoAutoplayEnabled && jQuery(this).find("video").length > 0) {
					setTimeout(function () {
						jQuery('.product-gallery-popup-item__img .swiper-slide-active video').get(0).play();
					}, 1000);
				}

			});
		}
		
		jQuery(".product-gallery-popup .product-gallery-popup__box .container .product-gallery-popup-item .close-product-gallery-popup").click(function (e) {
			e.preventDefault();
			jQuery('.product-gallery-popup video').each(function() {
				this.pause();
			});
			jQuery('.product-gallery-popup').fadeOut(300);
			jQuery("html").css("overflow", "inherit");
		});
		jQuery(".product-gallery-popup .product-gallery-popup__box").click(function (e) {
			e.stopPropagation();
			jQuery('.product-gallery-popup video').each(function() {
				this.pause();
			});
			jQuery('.product-gallery-popup').fadeOut(300);
			jQuery("html").css("overflow", "inherit");
		});
		jQuery(".product-gallery-popup .product-gallery-popup__box .product-gallery-popup-item").click(function (e) {
			e.stopPropagation();
		});
	}



}


function faqs() {
	//footer
	if (jQuery(window).width() <= 992) {
		jQuery("footer .footer__main .footer__main__menus .menu>li span").click(function () {
			jQuery(this).toggleClass("is-active");
			jQuery(this).siblings("ul").slideToggle(300);

		});
	}

	jQuery(".accordion-items .accordion-item .accordion-title").click(function () {
		jQuery(this).toggleClass("is-active");
		jQuery(this).siblings(".accordion-text").slideToggle(300);
		jQuery(this).parents(".accordion-item").siblings().find(".accordion-title").removeClass("is-active");
		jQuery(this).parents(".accordion-item").siblings().find(".accordion-text").slideUp(300);
	});

	jQuery(".intro-text .btn-arrow").each(function () {
		jQuery(this).parents(".intro-text").addClass("style-faq-page");
	});

}

function headerHeight() {
	setTimeout(() => {
		var headerHeight = jQuery(".header").outerHeight();
		jQuery("#MainContent").css('padding-top', headerHeight + 'px');
	}, 10);
}

function gallerySliderHeight() {
	var winHeight = window.innerHeight;
	jQuery(".product-gallery-popup-item").css("height", winHeight + "px");
}

function sellingPlansArrowHide() {
	const addHideArrowClass = () => {
		jQuery(".rc-selling-plans-single").parent(".rc-selling-plans").addClass("hide-arrow");
	};

	setTimeout(addHideArrowClass, 500);
	jQuery(document).on("change", ".recharge-subscription-widget .rc-radio", addHideArrowClass);
}

function subMenuFullWidth() {
	jQuery("li.full-megamenu").each(function () {
		var $li = jQuery(this);
		var winWidth = jQuery(window).width();
		var liLeftOffset = $li.offset().left;
		var liRightOffset = winWidth - liLeftOffset - $li.outerWidth();
		if ($(".section-header").hasClass("tablet-menu-collapse")) {
			if (winWidth > 1200) {
				$li.find(".sub-menu-content").css({
					'left': '-' + liLeftOffset + 'px',
					'right': '-' + liRightOffset + 'px'
				});
			}
		}
		else {
			if (winWidth > 992) {
				$li.find(".sub-menu-content").css({
					'left': '-' + liLeftOffset + 'px',
					'right': '-' + liRightOffset + 'px'
				});
			}
		}

	});
}

function checkSearchbarExist() {
	if (!jQuery('body').find('.header__search').length) {
		jQuery(".header__top").addClass("no-search");
	}
}
function checkSubscription() {
	jQuery(function ($) {
		setTimeout(function () {
			var $widget = $(".pdp-details__item__right--sticky").find('.recharge-subscription-widget');

			if ($widget.length > 0) {
				var pdpHeight = $(".pdp-details__item__right__box").outerHeight(true); // Use outerHeight(true) to include margins
				$('.pdp-details__item__left.product').css('min-height', pdpHeight + 'px');
			}
		}, 300);

	});

}

// function humbergerTopPosition() {
// 	var navTop = jQuery(".header__top__box").outerHeight() + jQuery(".header__swiper").outerHeight() + 10;
// 	jQuery("body .header .header__menu").css('top',navTop + 'px' )
// }

function humbergerTopPosition() {
	const $headerTopBox = jQuery(".header__top__box");
	const $headerSwiper = jQuery(".header__swiper");
	const $headerMenu = jQuery("body .header .header__menu");

	if ($headerTopBox.length && $headerSwiper.length && $headerMenu.length) {
		const navTop = $headerTopBox.outerHeight() + $headerSwiper.outerHeight() + 10;
		$headerMenu.css('top', `${navTop}px`);
	} else if ($headerTopBox.length && $headerMenu.length) {
		const navTop = $headerTopBox.outerHeight() + 10;
		$headerMenu.css('top', `${navTop}px`);
	}
}
